import React from 'react'
import "./Footer.css";
import "../../assets/css/app.css";
import { Link } from "react-router-dom";
import paytechlogo from "../../assets/imgs/logo.svg";
import phneIcon from "../../assets/imgs/icons/phne-icon.svg";
import emlIcon from "../../assets/imgs/icons/email-icon.svg";

function Footer() {
  return (
    <div className='ftrMn'>
      <div className="maxW">
        <div className="ftrConts">
        
          <div className='flogWrp'>
            <img src={paytechlogo} alt="PayTech-Advisor-Logo" />
          </div>

          
          <div className='fsrvWrp'>
            <h3>OUR SERVICES</h3>
            <Link to="/payment-strategy-and-advisory">Payment Strategy & Advisory</Link>
            <Link to="/tech-and-cloud-solution">Tech & Cloud Solutions</Link>
            <Link to="/business-consultancy">Business Consultancy</Link>
            <Link to="/marketing">360° Marketing</Link>
          </div>

         
          <div className='fqckWrp'>
            <h3>QUICK LINKS</h3>
            <Link to="/">Home</Link>
            <Link to="/about-us">About Us</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>

        
          <div className='fgtWrp'>
            <h3>GET IN TOUCH</h3>
            <a
              href='https://www.google.com/maps?q=Assotech+Business+Cresterra,+Sector-135,+Noida,+Gautam+Buddha+Nagar,+Uttar+Pradesh-201305'
              target='_blank'
              rel='noopener noreferrer'
              className='coCard'
            >
              Assotech Business Cresterra, <br />
              Sector 135 Noida U.P, India – 201301
            </a>


            <a href="tel:+919811137560">
              <img src={phneIcon} alt="phone" /> +91 98111 37560
            </a>
            <a href="mailto:kamal@paytechadvisors.com">
              <img src={emlIcon} alt="email" /> kamal@paytechadvisors.com
            </a>
          </div>
        </div>

     
        <div className="ftcnBtm">
          <div className='coPara'>
            <p>© 2025. Paytech Advisors. Developed by <a href="https://cfcs.co.in" target="_blank" rel="noreferrer">CFCS</a></p>
          </div>
          <div className='prsLnks'>
            <Link to="/terms-and-condition">Terms & Conditions</Link>
             <Link to="/refund-policy">Refund policy</Link>
            <Link to="/privacy-policy">Privacy policy</Link>
          </div>
        </div>

        <div className='fthdBm'>
          <p>Paytech Advisors - A Unit Of K.M Enterprises</p>
        </div>
      </div>
    </div>
  )
}

export default Footer
